import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/auth/profile`;

export default {
  getProfile(payload = {}) {
    return Client.get(resource, {
      params: payload,
    });
  },
  updateProfile(payload) {
    return Client.post(resource, payload);
  },
  updateOffline(payload) {
    return Client.post(`${resource}/offline`, payload);
  },
  updateChatSettings(payload) {
    return Client.post(`${resource}/chat-settings`, payload);
  },
  updatePassword(payload) {
    return Client.post(`${resource}/password`, payload);
  },
  updateWhitelistIP(payload) {
    return Client.put(`${Config.basePath}/merchant/whitelist`, payload);
  },
};
